export default __webpack_public_path__ + "static/media/FAQ.60c20813.png";